<!-- Desktop: columna sin caja contenedora, cada boton es su propia superficie.
     Mobile: dentro del bottom sheet, titulo y filas centradas. -->
<div
    #venueLayoutContainer
    class="pointer-events-auto opacity-0"
    [class]="{'hidden': hideElement()}"
    [attr.aria-hidden]="hideElement()"
>

    <h3 class="md:hidden pb-4 text-center text-base font-semibold text-white">
        Select Venue Layout
    </h3>

    <div class="flex flex-wrap justify-center gap-2.5 md:flex-col md:flex-nowrap md:items-center">

        @for (entry of options(); track entry.id) {

            <app-button
                [attr.title]="entry.label"
                [custom]="['size-12 flex items-center justify-center p-0']"
                [type]="buttonType"
                [active]="entry.id === venueLayout.venueConfigs.activeId()"
                [label]="entry.showIcon ? '' : entry.label"
                (event)="venueLayout.selectConfiguration(entry.id)"
            >
                @if (entry.showIcon) {
                    <app-venue-icon ngProjectAs="icon" role="img" [attr.aria-label]="entry.label" [id]="entry.icon"/>
                }
            </app-button>

        }

    </div>

</div>
